/**
 * WHICH HERO A VISITOR GETS — project100 T1010, DORMANT BY DEFAULT.
 *
 * The variant this serves ("minimal": the promise and the field, without the badge, the headline
 * or the secondary links) exists to be A/B-tested against today's hero, and that test — T1011 —
 * can only mean something once there is traffic to split. So this ships DORMANT: unless something
 * explicitly asks for the variant, `full` is returned and the page is byte-for-byte the hero that
 * is live today.
 *
 * WHY A URL PARAM AND NOT THE POSTHOG FLAG (measured 2026-10-04). The obvious mechanism is
 * PostHog's own feature flag (the SDK is installed), and at ACTIVATION that is the right home for
 * the random-share assignment, because assignment is a measurement concern and @P123 owns the
 * measurement stack. It cannot be the mechanism today: PostHog is deliberately OFF on DEV —
 * `scripts/fetch-secrets.sh` writes an EMPTY key for any project that is not a tracked build
 * ("D-232-004: only PROD is tracked … so no PostHog event can leave this build"), and the DEV
 * bundle logs `[POSTHOG][init_010] VITE_POSTHOG_KEY not set — PostHog disabled`. A flag read from
 * a disabled SDK is a switch nobody can flip, so the variant could not be looked at on the only
 * environment we have. The explicit `?hero=minimal` is what makes it verifiable there; the build
 * variable is what a tracked (PROD) arm would use.
 *
 * Resolution order, first match wins:
 *   1. `?hero=minimal` in the URL — look at the variant on any environment, including DEV.
 *   2. `VITE_HERO_VARIANT=minimal` — a deployed arm, for a tracked build.
 *   3. `full` — today's hero. The default is the live page, so nothing changes by accident.
 */
export type HeroVariant = 'full' | 'minimal';

export function resolveHeroVariant(search?: string): HeroVariant {
  const query = search ?? (typeof window === 'undefined' ? '' : window.location.search);
  if (new URLSearchParams(query).get('hero') === 'minimal') return 'minimal';

  const env = import.meta.env as Record<string, string | undefined>;
  if (env.VITE_HERO_VARIANT === 'minimal') return 'minimal';

  return 'full';
}
